import { module } from 'angular';

import { VERSION_CHECK_SERVICE } from './versionCheck.service';

export const CONFIG_MODULE = 'spinnaker.core.config';
module(CONFIG_MODULE, [
  VERSION_CHECK_SERVICE,
]);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/config/config.module.ts